module.exports = __webpack_public_path__ + "static/media/audioIcon.6b7676b6.png";